import { CycleUtils } from './cycle-utils';
const SEARCH_PARAMS = {
  DOMAIN_NAME: 'domainName',
  SITE_GUID: 'siteGuid',
  PRODUCT_ID: 'productId',
  CYCLE_ID: 'cycleId',
  IS_DOWNGRADE_ENABLED: 'isChangePlan',
  REFERRAL_ADDITIONAL_INFO: 'referralAdditionalInfo',
  SHOW_DOMAIN: 'showDomain',
  REFERRER: 'referrer',
  DEBUG: 'debug',
  OVERRIDE_SUBSCRIPTION_ID: 'existingUserPackageGuid',
  SUCCESS_URL: 'successUrl'
};
export const getSearchParams = () => {
  const searchParams = new URLSearchParams(location.search);
  const domainName = searchParams.get(SEARCH_PARAMS.DOMAIN_NAME) ?? undefined;
  const siteGuid = searchParams.get(SEARCH_PARAMS.SITE_GUID) ?? undefined;
  const productId = searchParams.get(SEARCH_PARAMS.PRODUCT_ID) ?? undefined;
  const cycleId = CycleUtils.validateCycleId(searchParams.get(SEARCH_PARAMS.CYCLE_ID)) ?? undefined;
  const isDowngradeEnabled = searchParams.get(SEARCH_PARAMS.IS_DOWNGRADE_ENABLED) === 'true';
  const debug = searchParams.get(SEARCH_PARAMS.DEBUG) === 'true';
  const overrideSubscriptionId = searchParams.get(SEARCH_PARAMS.OVERRIDE_SUBSCRIPTION_ID) ?? undefined;
  const referralAdditionalInfo = searchParams.get(SEARCH_PARAMS.REFERRAL_ADDITIONAL_INFO) ?? undefined;
  const showDomain = searchParams.get(SEARCH_PARAMS.SHOW_DOMAIN) === 'true';
  const referrer = searchParams.get(SEARCH_PARAMS.REFERRER) ?? undefined;
  const successUrl = searchParams.get(SEARCH_PARAMS.SUCCESS_URL) ?? undefined;
  return {
    allSearchParams: searchParams,
    domainName,
    siteGuid,
    productId,
    cycleId,
    referralAdditionalInfo,
    showDomain,
    referrer,
    isDowngradeEnabled,
    debug,
    overrideSubscriptionId,
    successUrl
  };
};
//# sourceMappingURL=getSearchParams.js.map